import {
    ALCHEMISTEN,
    Color,
    CubeTextureLoader,
//    GammaEncoding,
    LinearMipMapLinearFilter,
    MeshBasicMaterial,
    MeshLambertMaterial,
    MeshPhongMaterial,
    MeshPhysicalMaterial,
    MeshStandardMaterial,
//    PMREMGenerator,
//    PMREMCubeUVPacker,
    RepeatWrapping,
    RGBFormat,
    TextureLoader
} from 'da-three';

export default class MaterialManager {
    constructor(mediator, config, edMaterials, edEnvironments, directory, proFold, renderer) {
        this.config = config;
        this.mediator = mediator;
        this.renderer = renderer;
        this.materials = [];
        this.colorChange = null;
        this.environments = [];
        this.basedir = directory;
        this.projectFolder = proFold;
        this.auth = ALCHEMISTEN.instance.auth;
        this.ldrCubeRenderTarget = {
            texture: {}
        };
        this.defTex = {
            diffuse: this.loadTexture(this.basedir+config.project.static+'textures/default/mapDiffuse.png'),
            normal: this.loadTexture(this.basedir+config.project.static+'textures/default/mapNormal.png')
        };
        
        this.createEnvironments(edEnvironments);
        this.createMaterials(edMaterials);
        this.colorChange = this.getChangeableMaterials();
        
        this.mediator.addEventListener('objectComplete', (event,object) => this.assignMaterials(object,this.config.object));
    }
    
    
    
    addNewMaterial(matObj){
        this.createMaterial(matObj);
    }
    


    assignMaterials(object,fileData){
        const scope = this;
        const env = this.environments.length > 0 ? this.environments[0] : null;
        object.traverse(function (node) {
            if (node.isMesh && node.material) {
                let sLength = fileData.slots.length;
                for (let i=0;i<sLength;i++){
                    if (node.material.name === fileData.slots[i].name){
                        let assignMe = scope.getMaterialByDBID(fileData.slots[i].materialID);
                        if (assignMe !== false) {
                            if (node.isSkinnedMesh){
                                assignMe.skinning = true;
                            }
                            node.material = assignMe;
                        } else {
                            console.error('No material found with db ID: '+fileData.slots[i].materialID);
                        }
                    }
                }
            }


            if (env && node.material && 'envMap' in node.material) {
                node.material.envMap = env;
                node.material.needsUpdate = true;
            }
        });
    }
    
    
    
    changeMaterialColor(color,materialName){
        let texMaterial = this.getMaterialByName(materialName);
        let newColor = new Color(parseInt((''+color).replace("#", "0x"),16));
        texMaterial.color = newColor;
    }
    


    createEnvironments(edEnvironments){
        let eLength = edEnvironments.length;
        for (let i=0;i<eLength;i++){
            let envPath = this.basedir+this.config.project.static+'textures/environments/'+edEnvironments[i].folder+'/';
            let envMap = [                
                envPath + 'neg-x.jpg',
                envPath +'pos-x.jpg',
                envPath +'pos-y.jpg',
                envPath +'neg-y.jpg',
                envPath +'pos-z.jpg',
                envPath +'neg-z.jpg'
            ];

            let cubeLoader = new CubeTextureLoader();
            cubeLoader.crossOrigin = ' ';
//            let scope = this;
//            cubeLoader.load(envMap, function(reflectionCube){
//                reflectionCube.encoding = GammaEncoding;
//
//                let pmremGenerator = new PMREMGenerator(reflectionCube);
//                pmremGenerator.update(scope.renderer);
//                let pmremCubeUVPacker = new PMREMCubeUVPacker(pmremGenerator.cubeLods);
//                pmremCubeUVPacker.update(scope.renderer);
//
//                scope.ldrCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget;
//                scope.ldrCubeRenderTarget.texture.dbID = edEnvironments[i].id;
//                scope.environments.push(scope.ldrCubeRenderTarget.texture);
//                console.log('One: ',scope.ldrCubeRenderTarget);
//            });
            

            let reflectionCube = cubeLoader.load(envMap);
            reflectionCube.format = RGBFormat;
            reflectionCube.dbID = edEnvironments[i].id;
            this.environments.push(reflectionCube);      
        }
    }
    


    createMaterial(matObj){
        let texParams = {
            lights: matObj.lights,
            name: matObj.name,
            opacity: matObj.opacity,
            side: matObj.side
        };
        
        
        //Transparency
        if (matObj.alphaMap !== '' && matObj.alphaMap !== null){
            texParams.alphaMap = this.loadTexture( this.basedir+this.projectFolder + matObj.alphaMap);
        }
        if (texParams.opacity < 1 || texParams.alphaMap !== undefined){
            texParams.transparent = true;
        }
        
        //Ambient occlusion
        if (matObj.aoMap !== '' && matObj.aoMap !== null){
            texParams.aoMapIntensity = matObj.aoMapIntensity;
            texParams.aoMap = this.loadTexture( this.basedir+this.projectFolder + matObj.aoMap);
        }
        
        //Bump map
        if (matObj.bumpMap !== '' && matObj.bumpMap != null){
            texParams.bumpScale = matObj.bumpScale;
            texParams.bumpMap = this.loadTexture( this.basedir+this.projectFolder + matObj.bumpMap );
            texParams.bumpMap.wrapS = RepeatWrapping;
            texParams.bumpMap.wrapT = RepeatWrapping;
            texParams.bumpMap.anisotropy = 4;
            texParams.bumpMap.format = RGBFormat;
        }
        
        //Clear coat
        texParams.clearCoat = matObj.clearCoat;
        texParams.clearCoatRoughness = matObj.clearCoatRoughness;
 
        //Diffuse
        texParams.color = new Color(parseInt((''+matObj.color).replace("#", "0x"),16));
        texParams.combine = matObj.combine;
        if (matObj.map !== '' && matObj.map !== null){
            texParams.map = this.loadTexture( this.basedir+this.projectFolder + matObj.map );
        }else{
            texParams.map = this.defTex.diffuse;
        }
        texParams.map.wrapS = RepeatWrapping;
        texParams.map.wrapT = RepeatWrapping;
        texParams.map.magFilter = LinearMipMapLinearFilter;
        texParams.map.minFilter = LinearMipMapLinearFilter;
        
        //Displacement map
        if (matObj.displacementMap !== '' && matObj.displacementMap != null){
            texParams.displacementScale = matObj.displacementScale;
            texParams.displacementBias = matObj.displacementBias;
            texParams.displacementMap = this.loadTexture( this.basedir+this.projectFolder + matObj.displacementMap );
            texParams.displacementMap.wrapS = RepeatWrapping;
            texParams.displacementMap.wrapT = RepeatWrapping;
            texParams.displacementMap.anisotropy = 4;
            texParams.displacementMap.format = RGBFormat;
        }
        
        //Emissive map
        texParams.emissive = new Color(parseInt((''+matObj.emissive).replace("#", "0x"),16));
        texParams.emissiveIntensity = matObj.emissiveIntensity;
        if (matObj.emissiveMap !== '' && matObj.emissiveMap != null){
            texParams.emissiveMap = this.loadTexture( this.basedir+this.projectFolder + matObj.emissiveMap );
            texParams.emissiveMap.wrapS = RepeatWrapping;
            texParams.emissiveMap.wrapT = RepeatWrapping;
            texParams.emissiveMap.anisotropy = 4;
            texParams.emissiveMap.format = RGBFormat;
        }
        
        //Environment Map
        if (matObj.envID !== null){
            texParams.envMap = this.searchEnvironmentByDBID(matObj.envID);
        }
        
        //Metalness
        texParams.metalness = matObj.metalness;
        if (matObj.metalnessMap !== '' && matObj.metalnessMap != null){
            texParams.metalnessMap = this.loadTexture( this.basedir+this.projectFolder + matObj.metalnessMap );
            texParams.metalnessMap.wrapS = RepeatWrapping;
            texParams.metalnessMap.wrapT = RepeatWrapping;
            texParams.metalnessMap.anisotropy = 4;
            texParams.metalnessMap.format = RGBFormat;
        }
        
        //Normal Map
        if (matObj.normalMap !== '' && matObj.normalMap != null){
            texParams.normalMapScale = matObj.normalMapScale;
            texParams.normalMap = this.loadTexture( this.basedir+this.projectFolder + matObj.normalMap );
        }
        
        //Reflectivity
        texParams.reflectivity = matObj.reflectivity;
        
        //Refraction ratio
        texParams.refractionRatio = matObj.refractionRatio;
        
        //Roughness
        texParams.roughness = matObj.roughness;
        if (matObj.roughnessMap !== '' && matObj.roughnessMap != null){
            texParams.roughnessMap = this.loadTexture( this.basedir+this.projectFolder + matObj.roughnessMap );
            texParams.roughnessMap.wrapS = RepeatWrapping;
            texParams.roughnessMap.wrapT = RepeatWrapping;
            texParams.roughnessMap.anisotropy = 4;
            texParams.roughnessMap.format = RGBFormat;
        }
        
        //Shininess
        texParams.shininess = matObj.shininess;
        
        //Skinning
        texParams.skinning = matObj.skinning;

        //Specular
        texParams.specular = new Color(parseInt((''+matObj.specular).replace("#", "0x"),16));
        if (matObj.specularMap !== '' && matObj.specularMap != null){
            texParams.specularMap = this.loadTexture( this.basedir+this.projectFolder + matObj.specularMap );
        }              
        
               
        //Create material based on type
        let mat = {};
        switch (matObj.type){
            case 'basic':
                mat = new MeshBasicMaterial(texParams);
                break;
            case 'lambert':
                mat = new MeshLambertMaterial(texParams);
                break;
            case 'phong':
                delete texParams.clearCoat;
                delete texParams.clearCoatRoughness;
                delete texParams.metalness;
                delete texParams.normalMapScale;
                delete texParams.roughness;
                mat = new MeshPhongMaterial(texParams);
                break;
            case 'physical':
                delete texParams.combine;
                delete texParams.shininess;
                delete texParams.specular;
                mat = new MeshPhysicalMaterial(texParams);
                break;
            case 'standard':
                delete texParams.clearCoat;
                delete texParams.clearCoatRoughness;
                delete texParams.combine;
                delete texParams.reflectivity;
                delete texParams.shininess;
                delete texParams.specular;
                mat = new MeshStandardMaterial(texParams);
                break;
            default:
                mat = new MeshPhongMaterial(texParams);
                break;
        }
        mat.dbID = matObj.id;
        mat.changeable = matObj.changeable;
        if (matObj.envID !== null){
           mat.useEnv = true;
        }
        mat.needsUpdate = true;
        
        this.materials.push(mat);
    }
    


    createMaterials(edMaterials){
        let mLength = edMaterials.length;
        for (let i=0;i<mLength;i++){
            this.createMaterial(edMaterials[i]);
        }
    }
    
    
    
    getChangeableMaterials(){
        if (this.colorChange === null){
            this.colorChange = [];
            let mLength = this.materials.length;
            for (let i=0;i<mLength;i++){
                if (this.materials[i].changeable){
                    this.colorChange.push(this.materials[i].name);
                }
            }
        }

        return this.colorChange;
    }



    getEnvironmentByDBID(envID){
        return this.searchEnvironmentByDBID(envID);
    }
    


    getEnvironments(){
        return this.environments;
    }



    getMaterialByDBID (id){
        if (id === -1){
            return null;
        }else{
            let mLength = this.materials.length;
            for (let i=0;i<mLength;i++){
                if (this.materials[i].dbID === id)
                        return this.materials[i];
            }

            return false;
        }
    }
    
    
    
    getMaterialByName (name) {
        let mLength = this.materials.length;
        for (let i=0;i<mLength;i++){
            if (this.materials[i].name === name)
                    return this.materials[i];
        }

        return false;
    }



    getMaterials(){
        return this.materials;
    }
    


    loadTexture( url, mapping, onLoad, onError ) {
        let texLoader = new TextureLoader();
        texLoader.crossOrigin = " ";
        if (this.auth.isLoggedIn) {
            url += `?token=${localStorage.getItem('DAStudioAuthToken')}`;
        }
        let texture = texLoader.load(url, function(){
            if (onLoad){
                onLoad(texture);
            }
        });
        texture.minFilter = LinearMipMapLinearFilter;
        

        return texture;
    }



    searchEnvironmentByDBID(envID){
        let eLength = this.environments.length;
        for (let i=0;i<eLength;i++){
            if (this.environments[i].dbID === envID){
                return this.environments[i];
            }
        }

        return false;
    }



    setMaterialProperty(matID,type,value){
        let mat = this.getMaterialByDBID(matID);

        switch(type){
            case 'changeable':
                //Nothing to do, not relevant in editor
                break;		
            case 'colorDiffuse':
                console.log(matID+': Assigning material color: '+value);
                mat.color = new Color(parseInt((''+value).replace("#", "0x"),16));
                break;
            case 'colorAmbient':
                mat.ambient = new Color(parseInt((''+value).replace("#", "0x"),16));
                break;
            case 'colorSpecular':
                mat.specular = new Color(parseInt((''+value).replace("#", "0x"),16));
                break;
            case 'mapAlpha':
                break;
            case 'mapAmbient':
                if (value !== null && value !== ''){
                    mat.lightMap = this.loadTexture( this.basedir+this.projectFolder + value );
                }else{
                    mat.lightMap = null;
                }
                mat.lightMap.needsUpdate = true;
                mat.needsUpdate = true;
                break;
            case 'mapBump':
                if (value !== null && value !== ''){
                    mat.bumpMap = this.loadTexture( this.basedir+this.projectFolder + value );
                }else{
                    mat.bumpMap = null;
                }
                mat.bumpMap.needsUpdate = true;
                mat.needsUpdate = true;
                break;
            case 'mapDiffuse':
                if (value !== null && value !== ''){
                    let diffTexture = this.loadTexture(this.basedir + this.projectFolder + value);
                    diffTexture.magFilter = LinearMipMapLinearFilter;
                    diffTexture.minFilter = LinearMipMapLinearFilter;
                    diffTexture.anisotropy = 16;
                    mat.map = diffTexture;
                }else{
                    //mat.map = this.defTex.diffuse;
                }
                mat.map.needsUpdate = true;
                mat.needsUpdate = true;
                break;
            case 'mapDisplacement':
                break;
            case 'mapEnvironment':
                mat.envMap = this.searchEnvironmentByDBID(value);
                mat.needsUpdate = true;
                break;
            case 'mapNormal':
                if (value !== null && value !== ''){
                    mat.normalMap = this.loadTexture( this.basedir+this.projectFolder + value );
                }else{
                    mat.normalMap = null;
                }
                mat.normalMap.needsUpdate = true;
                mat.needsUpdate = true;
                break;
            case 'mapSpecular':
                if (value !== null && value !== ''){
                    mat.specularMap = this.loadTexture( this.basedir+this.projectFolder + value );
                }else{
                    mat.specularMap = null;
                }
                mat.specularMap.needsUpdate = true;
                mat.needsUpdate = true;
                break;
            case 'name':
                mat.name = value;
                break;
            case 'opacity':
                mat.opacity = value;
                mat.transparent = (value !== 1);
                break;
            case 'reflectivity':
                mat.reflectivity = value;
                break;
            case 'shininess':
                mat.shininess = value;
                break;
            default:
                break;
        }
    }
        
    
    
    setWireframeEnabled(newValue){
        let mLength = this.materials.length;
        for (let i=0;i<mLength;i++){
            this.materials[i].wireframe = newValue;
        }
    }



    updateMaterialDBID(oldID,newID){
        let mat = this.getMaterialByDBID(oldID);
        mat.dbID = newID;
    }
};


// WEBPACK FOOTER //
// ./src/js/studio/manager/MaterialManager.js